<div class="page-boxed">

    <mce-save-cancel [config]="saveCancelConfig()"
                     (action)="onSaveCancelAction($event)">
    </mce-save-cancel>

    <div class="mt-8 flex flex-row gap-4">

        <div class="min-w-0 flex-grow">
            <project-edit-description [form]="form.description"></project-edit-description>
            <project-edit-default-values [form]="form.defaultValues"></project-edit-default-values>
            <project-edit-branding [form]="form.branding"></project-edit-branding>
            <project-edit-comments [form]="form.comments"></project-edit-comments>
        </div>

        @if (showDebugPanel()) { <app-debug-panel [form]="form()" class="hidden md:block"></app-debug-panel> }

    </div>

</div>



